import { Component, OnInit, ViewChild, TemplateRef, Output, EventEmitter, } from '@angular/core';
import { NgBlockUI, BlockUI } from 'ng-block-ui';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerService } from 'src/app/_services/Customer/customer.service';
import { Dateconfig } from 'src/app/configuration/dateconfig/dateconfig';
import { ToastrService } from 'ngx-toastr';
import { CustomLoaderCComponent } from 'src/app/CustomLoader/custom-loader/custom-loader-c/custom-loader-c.component';
import { PerfectScrollbarConfigInterface, PerfectScrollbarComponent, PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NewProductItem } from 'src/app/Entites/Product/Product';
import { NewPayemnts } from 'src/app/Entites/Payments/Payments';
import { ProductItemService } from 'src/app/_services/productItem/product-item.service';
import { BillService } from 'src/app/_services/bill/bill.service';
import { Commonvariable } from 'src/app/commonvariable/commonvariable';
import { fakeAsync } from '@angular/core/testing';
import { LocalStorageConstants } from 'src/app/common/LocalStorageConstants';
import { CommonService } from 'src/app/common/common.service';

@Component({
  selector: 'app-add-bill',
  templateUrl: './add-bill.component.html',
  styleUrls: ['./add-bill.component.css'],
  providers: [Dateconfig, CustomLoaderCComponent, Commonvariable]
})
export class AddBillComponent implements OnInit {

  @ViewChild('ng-select') ngSelect;
  @BlockUI('singleSelect') blockUISingleSelect: NgBlockUI;
  @BlockUI('multipleSelect') blockUIMultipleSelect: NgBlockUI;
  @BlockUI() blockUI: NgBlockUI;
  @ViewChild('modalContent') modalContent: TemplateRef<any>;
  public config: PerfectScrollbarConfigInterface = {};
  @ViewChild(PerfectScrollbarComponent) componentRef?: PerfectScrollbarComponent;
  @ViewChild(PerfectScrollbarDirective) directiveRef?: PerfectScrollbarDirective;
  @Output() closeModalEvent = new EventEmitter<boolean>();

  /**
    *
    * @param NgbModal      modal
    */
  public customerarray;
  NewProductItem = new NewProductItem();

  NewPayemnts = new NewPayemnts();


  model: any = { isIgstBill: false };
  model1: any = { isIgstBill: false };
  rows1: any;
  rows: any;
  temp = [];
  options = {
    close: false,
    expand: true,
    minimize: true,
    reload: false
  };
  loading = false;
  submitted = false;
  customermodel: any = {}
  idBill: string;
  showcustomer: boolean = false;//
  booleanvalue: boolean = false;
  idBillmaster: string;
  totalMrp;
  totalAmountIncGST;
  discount;
  public currency = this.Commonvariable.currency;
  public f: NgForm;
  public productItems = [];
  public breadcrumb: any;
  public showCustomerdetails: boolean = false;
  public customer: any = {}
  public paymentsarray = [];
  public maxdate;
  public UserTypeDescription: string;
  public idLoggedInEmployee: number;
  public invoiceConfiguration: any = {};

  constructor(
    private CustomerService: CustomerService,
    private router: ActivatedRoute,
    private routernav: Router,
    private modalpop: NgbModal,
    private dateconfig: Dateconfig,
    private spinner: CustomLoaderCComponent,
    private toastrService: ToastrService,
    private productItemService: ProductItemService,
    private billService: BillService,
    private Commonvariable: Commonvariable,
    private commonService: CommonService,
  ) { 
      this.UserTypeDescription = localStorage.getItem(LocalStorageConstants.USER_TYPE_DESCRIPTION)
      this.idLoggedInEmployee = Number(localStorage.getItem(LocalStorageConstants.ID))
  }

  ngOnInit() {
    this.idBillmaster = this.router.snapshot.queryParamMap.get(LocalStorageConstants.ID);
    this.idBillmaster = atob(this.idBillmaster);
    this.GetAllCustomer();
    this.invoiceConfiguration = this.commonService.GetInvoiceConfiguration();
    console.log(this.invoiceConfiguration);

    this.model.billdate = this.dateconfig.getcurrentdate();
    if (Number(this.idBillmaster) >= 1) {
      document.title = 'Update Sale Bill';

      this.spinner.showSpinner();
      this.maxdate = this.dateconfig.getcurrentdate();
      this.billService.GetBillById(Number(this.idBillmaster)).subscribe(Response => {

        this.model = Response;
        this.model.billDate = this.dateconfig.getshortdate(this.model.billDate);
        this.breadcrumb = {
          'mainlabel': 'Update Sale Bill - ' + this.model.displayBillNumber
        };

        window.setTimeout(function () {

        }, 0);
        if (Response.listBillItems != null) {
          this.productItems = Response.listBillItems;

        }
        else {
          this.productItems = [];
        }
        if (Response.listPayment != null) {

          this.paymentsarray = Response.listPayment;
          for (var i = 0; i < this.paymentsarray.length; i++) {
            this.paymentsarray[i].paymentDate = this.dateconfig.getshortdate(this.paymentsarray[i].paymentDate);
          }
        }
        else {
          this.paymentsarray.push(this.NewPayemnts);
        }

        this.spinner.showSpinner();
        this.CustomerService.GetById(Number(Response.idCustomer)).subscribe(Response => {

          this.model.selectcustomer = Response;
          this.bindformcustomer(this.model.selectcustomer);
          this.spinner.hideSpinner();
        });
        this.spinner.hideSpinner();
      });
    }
    else {
      this.NewProductItem.productItemMRP = 0;
      this.NewProductItem.productItemPrice = 0;

      this.model.totalAmountIncGST = 0;
      this.model.totalpaidAmount = 0;
      this.model.balanceAmount = 0;
      this.model.discount = 0;
      this.AddForm();
      this.AddFormPaymentsarray();
      this.NewPayemnts.paymentDate = this.dateconfig.getcurrentdate();
      this.model.billDate = this.dateconfig.getcurrentdate();
      this.maxdate = this.dateconfig.getcurrentdate();
      this.model.payMode = "";
      this.breadcrumb = {
        'mainlabel': 'Add Sale Bill',
        'links': [
          {
            'name': 'Stock',
            'isLink': true,
            'link': '/stock/viewstock'
          },
        ]
      };
    }
  }

  GetAllCustomer() {
    this.spinner.showSpinner();
    this.CustomerService.GetAllCustomer().subscribe(Response => {
      if (Response != null) {
        this.rows = Response;
        this.customerarray = this.rows;
      }
      else {
        this.customerarray = [];
      }
      this.spinner.hideSpinner();
    });
  }

  bindformcustomer(selectcustomerdata) {
    this.showcustomer = false;
    if (selectcustomerdata == null) {
    }
    else {
      this.customermodel = selectcustomerdata;
      this.model.selectcustomer = selectcustomerdata;
      this.showcustomer = true;
    }
  }

  onScan(z) {
    this.spinner.showSpinner();
    this.productItemService.GetProductItemByBarCodeAndCheck(this.productItems[z].productItemBarCode).subscribe(Response => {
      if (Response != null) {
        this.productItems[z] = Response;
        this.productItems[z].operationState = "i";
        this.NewProductItem = new NewProductItem()
        this.NewProductItem.productItemMRP = 0;
        this.NewProductItem.productItemPrice = 0;
        this.NewProductItem.operationState = "i";
        this.productItems.push(this.NewProductItem);
        var num = new Number((this.productItems.length - 1));
        var x: string = "productItemBarCode" + num.toString();
        window.setTimeout(function () {
          document.getElementById(x).focus();
        }, 0);
      }
      else {
        this.toastrService.error("Barcode doesn't exist.", '', { timeOut: 3000, closeButton: true });
      }
      this.CalculateDiscount(0);
      this.spinner.hideSpinner();
    });
  }

  RemoveForm(index) {
    this.productItems[index].operationState = "d";
    this.CalculateDiscount(0);
  }

  AddForm() {
    this.NewProductItem = new NewProductItem()
    this.NewProductItem.productItemMRP = 0;
    this.NewProductItem.productItemPrice = 0;
    this.NewProductItem.operationState = "i";
    this.productItems.push(this.NewProductItem);
  }

  CalculateDiscount($event) {
    this.totalMrp = 0;
    this.totalAmountIncGST = 0;
    this.discount = 0;
    for (var i = 0; i < this.productItems.length; i++) {
      if (
        this.productItems[i].operationState != "d"
        && this.productItems[i].productItemPrice != undefined
        && this.productItems[i].productItemPrice != 0
      ) {
        this.totalMrp = this.totalMrp + this.productItems[i].productItemMRP;
        this.totalAmountIncGST = this.totalAmountIncGST + this.productItems[i].productItemPrice;
        this.discount = ((this.totalMrp - this.totalAmountIncGST) / this.totalMrp) * 100;
      }
    }
    this.model.totalMrp = this.totalMrp;
    this.model.totalAmountIncGST = this.totalAmountIncGST;
    this.model.discount = Math.round(Number(this.discount));
    if (this.model.discount == -Infinity) {
      this.model.discount = 0;
    }
    this.CalculatBalanceAmount()
  }

  

  saveBill(isValid: any) {
    this.model.billType = "sell";
    this.CalculateDiscount(0);
    if (this.model.totalAmountIncGST < this.model.totalpaidAmount) {
      this.toastrService.error("Customer pay extra ammount", '', { timeOut: 2000, closeButton: true });
      isValid = false;
    }
    for (var i = 0; i < this.paymentsarray.length; i++) {
      if (this.paymentsarray[i].operationState != "d" &&
        (this.paymentsarray[i].payMode == '' && this.paymentsarray[i].paidAmount > 0)) {
        this.toastrService.warning("Plese select payment method", '', { timeOut: 2000, closeButton: true });
        isValid = false;
        break;
      }
    }
    this.productItems.forEach(function (x) {
      if ((x.productItemMRP == null || x.productItemMRP == undefined) && x.operationState != "d") {
        x.productItemMRP = 0;
      }
    });

    if (isValid) {
      this.model.accountNumber = this.invoiceConfiguration.invoiceBankAcNo;
      this.model.ifscCode = this.invoiceConfiguration.invoiceBankIFSC;
      this.model.branchName = this.invoiceConfiguration.invoiceBankBranch;
      this.model.bankName = this.invoiceConfiguration.invoiceBankName;
      this.model.invoiceDeclaration = this.invoiceConfiguration.invoiceDeclaration;
      this.model.invoicePaymentTerm = this.invoiceConfiguration.invoicePaymentTerm;
      this.model.gstNo = this.invoiceConfiguration.invoiceBankGSTNo;
      if (Number(this.idBillmaster) < 0 || this.idBillmaster == "ée" || this.idBillmaster == null) {
        for (var i = 0; i < this.productItems.length; i++) {
          if (this.productItems[i].operationState == "d") {
            this.productItems.splice(i, 1);
          }
        }
        //check duplicate barcodes
        if (this.IsBarcodeDuplicate()) {
          this.toastrService.error("Please check duplicate barcodes!", 'Validation', { timeOut: 2000, closeButton: true });
          return;
        }
        for (var i = 0; i < this.paymentsarray.length; i++) {
          if (this.paymentsarray[i].operationState == "d") {
            this.paymentsarray.splice(i, 1);
          }
        }
        this.model.listPayment = this.paymentsarray;
        this.model.listBillItems = this.productItems;
        this.model.idCustomer = this.model.selectcustomer.idCustomer;
        this.model.createdBy = this.idLoggedInEmployee;
        this.spinner.showSpinner();
        this.billService.saveBill(this.model).subscribe(
          (res: any) => {
            if (res.result >= 1) {
              this.spinner.hideSpinner();
              this.toastrService.success(res.userMessage, '', { timeOut: 2000, closeButton: true });

              window.open('/viewbill?Id=' + btoa(res.idBillmaster) + '', '_blank');
              //    this.cancel();
              this.routernav.navigate(['/bill/allbill']);
            }
            else {
              this.spinner.hideSpinner();
              this.toastrService.error(res.userMessage, '', { timeOut: 3000, closeButton: true });
            }
          },
          err => {
            this.spinner.hideSpinner();

            this.toastrService.error('server down', '', { timeOut: 3000, closeButton: true });
          }
        )
      }
      else if (Number(this.idBillmaster) > 0) {
        for (var i = 0; i < this.productItems.length; i++) {
          if (this.productItems[i].idBillItem == undefined && this.productItems[i].operationState == "d") {
            this.productItems.splice(i, 1);
          }
        }
        for (var i = 0; i < this.paymentsarray.length; i++) {
          if (this.paymentsarray[i].operationState == "d" && this.paymentsarray[i].idPayment == undefined) {
            this.paymentsarray.splice(i, 1);
          }
        }

        //check duplicate barcodes
        if (this.IsBarcodeDuplicate()) {
          this.toastrService.error("Please check duplicate barcodes!", 'Validation', { timeOut: 2000, closeButton: true });
          return;
        }

        this.model.listPayment = this.paymentsarray;
        this.model.listBillItems = this.productItems;
        this.model.modifiedBy = this.idLoggedInEmployee;
        this.model.idCustomer = this.model.selectcustomer.idCustomer;
        this.spinner.showSpinner();
        this.billService.updateBill(this.model).subscribe(
          (res: any) => {
            if (res.result == 1) {
              this.spinner.hideSpinner();
              this.toastrService.success(res.userMessage, '', { timeOut: 2000, closeButton: true });
              window.open('/viewbill?Id=' + btoa(this.idBillmaster) + '', '_blank');
              //   this.cancel();
              this.routernav.navigate(['/bill/allbill']);
            }
            else {
              this.spinner.hideSpinner();
              this.toastrService.error(res.userMessage, '', { timeOut: 3000, closeButton: true });
            }
          },
          err => {
            this.spinner.hideSpinner();
            this.toastrService.error('server down', '', { timeOut: 3000, closeButton: true });
          }
        )
      }
    }
  }

  bcq: boolean = false;
  transactionId: boolean = false;
  CalculatBalanceAmount() {
    this.model.balanceAmount = this.model.totalAmountIncGST - this.model.totalpaidAmount;
  }
  AddFormPaymentsarray() {
    this.NewPayemnts = new NewPayemnts()
    this.NewPayemnts.paymentDate = this.dateconfig.getcurrentdate();
    this.NewPayemnts.paidAmount = 0;
    this.paymentsarray.push(this.NewPayemnts);
    window.setTimeout(function () {
    }, 0);
  }

  IsBarcodeDuplicate() {
    var isDuplicate = false;
    var barcodes = this.productItems.map(function (item) { if(item.operationState != 'd') return item.productItemBarCode });
    const filteredBarcodes = barcodes.filter(element => element !== undefined)
    isDuplicate = filteredBarcodes.some(function (item, idx) {
      return filteredBarcodes.indexOf(item) != idx
    });
    return isDuplicate;
  }

  RemoveFormPaymentsarray(i) {
    this.paymentsarray[i].operationState = "d";
    this.CalculateDiscount(0);
    this.CalculatTotalPaidAmount();
  }

  CalculatTotalPaidAmount() {
    this.model.totalpaidAmount = 0;
    for (var i = 0; i < this.paymentsarray.length; i++) {
      if (this.paymentsarray[i].operationState != "d"
        && (this.paymentsarray[i].paidAmount != undefined
          || this.paymentsarray[i].paidAmount != 0)
      ) {
        this.model.totalpaidAmount = Number(this.model.totalpaidAmount) + Number(this.paymentsarray[i].paidAmount);
      }
    }
    this.CalculatBalanceAmount();
  }

  updateOperationState(i) {
    if (this.paymentsarray[i].idPayment != undefined) {
      this.paymentsarray[i].operationState = "u";
    }
    this.CalculatTotalPaidAmount();
  }

  chnagePayMod(i) {
    if (this.paymentsarray[i].payMode == "By Cheque") {
      this.paymentsarray[i].transactionId = "";
    }
    if (this.paymentsarray[i].payMode == "By Cash") {
      this.paymentsarray[i].transactionId = "";
      this.paymentsarray[i].bankName = "";
      this.paymentsarray[i].branchName = "";
      this.paymentsarray[i].chequeNumber = "";
      this.paymentsarray[i].ifscCode = "";
    }
    if (this.paymentsarray[i].payMode == "By RTGS/NEFT" || this.paymentsarray[i].payMode == "By UPI") {
      this.paymentsarray[i].ifscCode = "";
      this.paymentsarray[i].bankName = "";
      this.paymentsarray[i].branchName = "";
      this.paymentsarray[i].chequeNumber = "";
    }
  }

  SaveCustomer(isValid: any) {
    if (isValid) {
      if (this.model.idCustomer == undefined) {
        this.spinner.showSpinner();
        this.model.createdBy = this.idLoggedInEmployee;
        this.CustomerService.savecustomer(this.model).subscribe(
          (res: any) => {
            if (res.result == 1) {
              this.cancel();
              this.bindformcustomer(res);
              this.customerarray.push(res);
              this.model.selectcustomer = res;
              this.customerarray = [this.customerarray];
              this.modalpop.dismissAll();
              this.spinner.hideSpinner();
              this.toastrService.success(res.userMessage, '', { timeOut: 2000, closeButton: true });
            }
            else {
              this.spinner.hideSpinner();
              this.toastrService.error(res.userMessage, '', { timeOut: 3000, closeButton: true });
            }
          },
          err => {
            this.spinner.hideSpinner();
            this.toastrService.error('server down', '', { timeOut: 3000, closeButton: true });
          }
        )
      }
    }
  }

  addcustomer(model: any) {
    this.model.action = "Add Customer"
    this.modalpop.open(this.modalContent, {
      size: 'lg', backdrop: 'static',
      keyboard: false
    });
  }

  updateOperationStateForBillItem(i) {
    if (this.productItems[i].idBillItem != undefined) {
      this.productItems[i].operationState = "u"
    }
  }

  cancel() {
    if (Number(this.idBillmaster) > 0) {
      this.routernav.navigate(['/bill/allbill']);
    }
    this.productItems = [];
    this.NewProductItem = new NewProductItem();
    this.NewProductItem.productItemMRP = 0;
    this.NewProductItem.productItemPrice = 0;
    this.NewProductItem.operationState = "i";
    this.productItems.push(this.NewProductItem);
    this.paymentsarray = [];
    this.NewPayemnts = new NewPayemnts();
    this.NewPayemnts.paymentDate = this.dateconfig.getcurrentdate();
    this.paymentsarray.push(this.NewPayemnts);
    this.showcustomer = false;
    this.showCustomerdetails = false;
    this.model = { isIgstBill: false };
    this.customermodel = {};
    this.modalpop.dismissAll();
    this.model.billDate = this.dateconfig.getcurrentdate();
    this.model.totalAmountIncGST = 0;
    this.model.totalpaidAmount = 0;
    this.model.balanceAmount = 0;
    this.model.discount = 0;
  }

  doNothing(f) {
  }
}